/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './primitive-node.component.scss.shim.ngstyle';
import * as i1 from '../node.component.scss.shim.ngstyle';
import * as i2 from '@angular/core';
import * as i3 from '@angular/common';
import * as i4 from '../../../../../app/multi-editor/json-tree/primitive-node/primitive-node.component';
const styles_PrimitiveNodeComponent:any[] = [i0.styles,i1.styles];
export const RenderType_PrimitiveNodeComponent:i2.RendererType2 = i2.ɵcrt({encapsulation:0,
    styles:styles_PrimitiveNodeComponent,data:{}});
function View_PrimitiveNodeComponent_1(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,0,(null as any),(null as any),2,'span',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),i2.ɵdid(1,
      278528,(null as any),0,i3.NgClass,[i2.IterableDiffers,i2.KeyValueDiffers,i2.ElementRef,
          i2.Renderer],{ngClass:[0,'ngClass']},(null as any)),(_l()(),i2.ɵted(2,(null as any),
      ['','']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.diff.op;
    _ck(_v,1,0,currVal_0);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.value;
    _ck(_v,2,0,currVal_1);
  });
}
function View_PrimitiveNodeComponent_2(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,0,(null as any),(null as any),8,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i2.ɵted(-1,(null as any),['\n        '])),(_l()(),i2.ɵeld(2,0,(null as any),
      (null as any),1,'span',[['class','add']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i2.ɵted(3,(null as any),['',''])),(_l()(),
      i2.ɵeld(4,0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i2.ɵted(-1,(null as any),
      ['\n        '])),(_l()(),i2.ɵeld(6,0,(null as any),(null as any),1,'span',[['class',
      'remove']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i2.ɵted(7,(null as any),['',''])),(_l()(),i2.ɵted(-1,(null as any),['\n    ']))],
      (null as any),(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.newValue;
        _ck(_v,3,0,currVal_0);
        const currVal_1:any = _co.value;
        _ck(_v,7,0,currVal_1);
      });
}
function View_PrimitiveNodeComponent_3(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,0,(null as any),(null as any),1,'span',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i2.ɵted(1,(null as any),['','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.value;
    _ck(_v,1,0,currVal_0);
  });
}
export function View_PrimitiveNodeComponent_0(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,0,(null as any),(null as any),10,'span',[['class',
      'value-text']],[[4,'margin-left','px']],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i2.ɵted(-1,(null as any),['\n    '])),(_l()(),i2.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_PrimitiveNodeComponent_1)),
      i2.ɵdid(3,16384,(null as any),0,i3.NgIf,[i2.ViewContainerRef,i2.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i2.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PrimitiveNodeComponent_2)),
      i2.ɵdid(6,16384,(null as any),0,i3.NgIf,[i2.ViewContainerRef,i2.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i2.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PrimitiveNodeComponent_3)),
      i2.ɵdid(9,16384,(null as any),0,i3.NgIf,[i2.ViewContainerRef,i2.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i2.ɵted(-1,(null as any),['\n  ']))],
      (_ck,_v) => {
        var _co:i4.PrimitiveNodeComponent = _v.component;
        const currVal_1:any = (_co.diff && (_co.diff.op !== 'replace'));
        _ck(_v,3,0,currVal_1);
        const currVal_2:any = (_co.diff && (_co.diff.op === 'replace'));
        _ck(_v,6,0,currVal_2);
        const currVal_3:boolean = !_co.diff;
        _ck(_v,9,0,currVal_3);
      },(_ck,_v) => {
        var _co:i4.PrimitiveNodeComponent = _v.component;
        const currVal_0:any = (_co.depth * 10);
        _ck(_v,0,0,currVal_0);
      });
}
export function View_PrimitiveNodeComponent_Host_0(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,0,(null as any),(null as any),1,'re-primitive-node',
      ([] as any[]),(null as any),(null as any),(null as any),View_PrimitiveNodeComponent_0,
      RenderType_PrimitiveNodeComponent)),i2.ɵdid(1,114688,(null as any),0,i4.PrimitiveNodeComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const PrimitiveNodeComponentNgFactory:i2.ComponentFactory<i4.PrimitiveNodeComponent> = i2.ɵccf('re-primitive-node',
    i4.PrimitiveNodeComponent,View_PrimitiveNodeComponent_Host_0,{value:'value',diff:'diff',
        depth:'depth'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/multi-editor/json-tree/primitive-node/primitive-node.component.ngfactory.ts